<mat-card class="card-table has-progress-bar transactions-card">
  <mat-progress-bar mode="determinate"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ title || 'common.transactions' | translate }}</span>
  </mat-card-title>

  <mat-card-content>
    <div
      *ngIf="transactionsTable.data && transactionsTable.data.length > 0"
      [style.display]="transactionsTable.data.length > 0 ? 'flex' : 'none'"
      fxLayout="column"
    >
      <table
        fxFlex
        mat-table
        class="mat-table--wide"
        [dataSource]="transactionsTable"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction; index as i">
            <a mat-button color="primary" [routerLink]="transaction.url"
              >{{ 'common.transaction' | translate }} {{ i + 1 }}</a
            >
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.date' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAt | momentDateTime: 'local' }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.method' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.methodDisplay | translate }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.type' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.typeDisplay | translate }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.status' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.statusDisplay | translate }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ 'common.total' | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.amount' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ (element.type === TYPE.REFUND ? -1 * element.amount: element.amount) | currency: element.currency }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ totalCollected | currency: 'USD' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="net">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.net' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ (element.details?.balance?.net || (element.type === TYPE.REFUND ? -1 : 1) * element.amount) | currency: element.currency }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ netTotalCollected | currency: 'USD' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'common.actions' | translate }}
          </th>
          <td mat-cell *matCellDef="let transaction">
            <button mat-icon-button [matMenuTriggerFor]="transactionMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #transactionMenu="matMenu">
              <button mat-menu-item [routerLink]="transaction.url">
                <mat-icon>web</mat-icon>
                {{ 'common.view-details' | translate }}
              </button>
              <button mat-menu-item (click)="send(transaction)">
                <mat-icon>send</mat-icon>
                {{ 'transactions.send-receipt-patient' | translate }}
              </button>
              <button mat-menu-item (click)="download(transaction)">
                <mat-icon>print</mat-icon>
                {{ 'transactions.print-receipt' | translate }}
              </button>
              <button
                mat-menu-item
                *ngIf="
                  (transaction.type === 'P' || transaction.type === 'C') &&
                  transaction.status === 'S'
                "
                [routerLink]="transaction.url"
                [disabled]="
                  invoice && invoice.paymentOption === 'P' && !invoice.isPayed
                "
              >
                <mat-icon>point_of_sale</mat-icon>
                {{ 'transactions.refund' | translate }}
              </button>
              <button
                mat-menu-item
                *ngIf="transaction.status === 'P'"
                [routerLink]="transaction.url"
                [disabled]="invoice && invoice.paymentOption === 'P'"
              >
                <mat-icon>point_of_sale</mat-icon>
                {{ 'transactions.capture' | translate }}
              </button>
              <!-- <button mat-menu-item (click)="refund(transaction)" *ngIf="transaction.details && transaction.type === 'P' && transaction.status === 'S'">
                <mat-icon>point_of_sale</mat-icon>
                Refund
              </button> -->
            </mat-menu>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>

      <mat-paginator
        [length]="transactionsTable.data.length"
        [pageSize]="10"
      ></mat-paginator>
    </div>

    <div *ngIf="transactionsTable.data && transactionsTable.data.length === 0" class="p-3">
      {{ 'transactions.no-transactions' | translate }}
    </div>
  </mat-card-content>
</mat-card>
